/** PC mentor join form (join/components/pc) */
export default {
	title: "Welcome to join SeerQ",
	page: {
		loading: "Loading...",
		submitting: "Submitting for review...",
		submitOk: "Submitted successfully. Pending review.",
		submitFail: "Submission failed. Please try again.",
		saving: "Saving...",
		saveOk: "Saved successfully",
		saveFail: "Save failed. Please try again.",
		mockOk: "Mock data filled successfully!",
		mockBtn: "Fill Mock Data",
	},
	actions: {
		back: "Back",
		backHome: "Return to Home",
		next: "Next Step",
		submitReview: "Submit for Review",
	},
	common: {
		cancel: "Cancel",
		confirm: "Confirm",
	},
	submitConfirm: {
		title: "Reminder",
		message:
			"Please confirm that all information is correct. Once submitted, it cannot be modified.",
		cancel: "Go Back and Edit",
		confirm: "Confirm Submit",
	},
	mentorForm: {
		language: "Language<br/> Used",
		languageM: "Language Used",
		languageOptions: {
			Mandarin: "Mandarin",
			Cantonese: "Cantonese",
			English: "English",
			Other: "Other",
		},
		languagePh: "Please select",
		otherLanguagePh: "Other languages you speak",
		stageName: "Stage Name",
		stageNamePh: "Please enter 2-5 Chinese characters",
		stageNameTip:
			"Your stage name is the official name you will use on SeerQ after joining. It may be your real name or a name you prefer. Please avoid hard-to-read, hard-to-remember, or obscure characters.",
		englishName: "English Name",
		englishNamePh: "Please enter an English name (max 16 characters)",
		gender: "Gender",
		genderFemale: "Female",
		genderMale: "Male",
		genderOther: "Other",
		location: "Region",
		locationPh: "Please select",
		email: "Email Address",
		emailPh: "Please enter a reachable email address",
		careerStartYear: "Years of<br/> Experience",
		careerStartYearM: "Years of Experience",
		careerStartYearPh: "Please select the year you started your practice",
		careerYearOption: "{year}",
		referrer: "Recommender",
		referrerPh: "If applicable, please fill in",
		teacherCategory: "Practitioner<br/> Type",
		teacherCategoryM: "Practitioner Type",
		teacherCategoryPh: "Please select",
		teacherSubCategoryPh: "Please select (up to 5)",
		bestExpertise: "Area of<br/> Expertise",
		bestExpertiseM: "Area of Expertise",
		bestExpertisePh: "Please select (up to 3)",
		proofImages: "Proof of Practice & Training",
		proofImagesTip:
			"You may upload training certificates, case examples, or award photos. Click to upload (max 5 files, each under 2MB).",
		personalIntroduction: "Personal Introduction (minimum 50 characters)",
		personalIntroductionPh:
			"We recommend including your strengths, experience, credentials, and areas of expertise in your introduction. Example: After two years of systematic study, I have developed a unique analytical framework through extensive client consultations. I specialize in love, career, and financial planning readings. My interpretations are detailed and thoughtful, earning consistent praise from clients. I am available from 9 AM to 8 PM daily — feel free to reach out anytime. (Do not copy this example, or your application will not be approved.)",
		editorLoading: "Loading editor...",
		validateFail: "Please check that the form is filled in correctly",
		pickImage: "Please select an image file",
		imageMax2mb: "Image size must not exceed 2MB",
		uploadNoUrl: "Upload failed: No image URL returned",
		uploadSuccess: "Image uploaded successfully",
		uploadFail: "Image upload failed",
		subCategoryMax: "You may select up to 5 subcategories",
		bestExpertiseMax: "You may select up to 3 areas of expertise",
		rules: {
			language: "Please select the language you use",
			otherLanguage: "Please enter other languages you speak",
			stageName: "Please enter a stage name of 2–5 Chinese characters",
			englishName: "Please enter an English name (max 16 characters)",
			gender: "Please select your gender",
			location: "Please select your region",
			email: "Please enter a reachable email address",
			emailFormat: "Please enter a valid email address",
			careerStartYear: "Please select your years of experience",
			teacherCategory: "Please select practitioner type",
			teacherSubCategories: "Please select practitioner subcategories",
			bestExpertise: "Please select your areas of expertise",
			proofImages: "Please upload proof of practice and training",
			personalIntroduction: "Please fill in your personal introduction",
			personalIntroductionMin: "Personal introduction must be at least 50 characters",
		},
	},
	listen: {
		title: "Test Questions",
		loading: "Loading questions...",
		noQuestions: "No test questions available",
		fetchFail: "Failed to load test questions. Please try again.",
		questionProgress: "Question {current} of {total}",
		noteTitle: "Instructions: ",
		text1:
			"1.Simulate a real consultation scenario. Extract key information based on your area of expertise and respond thoughtfully. ",
		text2:
			"2.Your answer must be logically clear, well-reasoned, and include both academic analysis and a clear conclusion. ",
		text3:
			"3.Only one audio file may be uploaded per question. Please keep the recording between 60–300 seconds. ",
		text4:
			'4.After finishing, upload the audio file and submit. <span class="recording-guide-link">Click to view the Recording Operation Manual.</span>',
		upload: "Click to Upload",
		uploading: "Uploading...",
		reupload: "Click to re-upload",
		uploaded: "Recording uploaded",
		pickAudio: "Please select an audio file",
		audioDuration: "Recording length must be between 60–300 seconds",
		uploadNoUrl: "Upload failed: No file URL returned",
		uploadSuccess: "Recording uploaded successfully",
		uploadFail: "Recording upload failed",
		uploadRequired: "Please upload a recording for this question before continuing",
		allUploadRequired: "Please upload recordings for all questions before continuing",
	},
	question: {
		title: "Survey Questionnaire",
		dec: "This questionnaire is used for onboarding assessment and research purposes. There are no right or wrong answers to any of the questions. Please answer based on your actual situation. All responses will be kept strictly confidential. Thank you for your support and cooperation!!",
		loading: "Loading questionnaire...",
		noQuestions: "No questionnaire items available",
		fetchFail: "Failed to load questionnaire. Please try again.",
		single: "Single choice",
		multiple: "Multiple choice",
		short: "Short answer",
		textareaPh: "Please enter your answer",
		answerRequired: "Please complete question {index}",
		submitting: "Submitting...",
		submitOk: "Questionnaire submitted successfully",
		submitFail: "Questionnaire submission failed. Please try again.",
	},
	status: {
		download: "Download the App",
		app: "See Beyond",
		back: "Back to Home",
		processing: {
			title: "Teacher qualification certification in progress",
			dec1: "Your information has been submitted for review. During the review period, the related information cannot be changed.",
			text1:
				"The review team will reply with the review result by email within 10 business days. Please keep an eye on your inbox. ",
			text2:
				"You may also download the SeerQ App to receive real-time notifications about the review progress and result. Thank you for your cooperation and support.",
		},
		join: {
			title: "Welcome to SeerQ",
			dec1: "You are now a contracted mentor on SeerQ. ",
			dec2: "Download the SeerQ to accept orders and provide guidance to users.",
		},
		failed: {
			title: "We're sorry, your mentor qualification review was not approved.",
			reason: "Reason",
			dec: "You may update your information based on the review feedback and resubmit.",
			edit: "Edit",
		},
	},
};
